import { useState } from "react"
import './App.css';
import { Addtask } from './components/Addtask';
import { Header } from './components/Header';
import { ShowTask } from './components/ShowTask';

function App() {

  const [tasklist, setTasklist] = useState(localStorage.getItem('tasklist') ? JSON.parse(localStorage.getItem('tasklist')) : []);
  const [task, setTask] = useState([]);
  const [edit, setEdit] = useState(false);
  const [dark, setDark] = useState(false);



    
    
  return (
    <div className='container mx-auto'>
      <Header dark={dark} setDark={setDark} />
      <Addtask edit={edit} setEdit={setEdit} task={task} setTask={setTask}  tasklist={tasklist} setTasklist={setTasklist} />
      <ShowTask  edit={edit} setEdit={setEdit} task={task} setTask={setTask} tasklist={tasklist} setTasklist={setTasklist} />
    </div>
  );
}

export default App;
